import { column, Css, GridColumn, GridDataRow, GridTable, numericColumn, simpleHeader } from "@homebound/beam";
import { useMemo } from "react";
import { emptyCellDash } from "src/components/gridTableCells";
import { PlanBasedLineItemsTab_LineItemFragment } from "src/routes/projects/commitments/components/PlanBasedLineItemsTab.generated";

type HeaderRow = { kind: "header" };
type DataRow = { kind: "data"; data: PlanBasedLineItemsTab_LineItemFragment };
type Row = HeaderRow | DataRow;

type ScopeLinesSectionProps = { lineItems: PlanBasedLineItemsTab_LineItemFragment[] };

export function ScopeLinesSection(props: ScopeLinesSectionProps) {
  const { lineItems } = props;
  const rows = useMemo<GridDataRow<Row>[]>(
    () => [
      simpleHeader,
      ...lineItems
        .filter((cli) => cli.primaryBidContractLineItem?.forCoveringTakeoffs)
        .map((cli) => ({ kind: "data" as const, id: cli.id, data: cli })),
    ],
    [lineItems],
  );
  return (
    <section data-testid="scopeLinesSection">
      <h2 css={Css.mdSb.mt3.mb1.$}>Scope Lines</h2>
      <GridTable columns={columns} rows={rows} fallbackMessage="No scope lines" />
    </section>
  );
}

const columns: GridColumn<Row>[] = [
  column<Row>({ header: () => "Item Code", data: (cli) => cli.projectItem.item.fullCode }),
  column<Row>({ header: () => "Name", data: (cli) => cli.projectItem.displayName }),
  column<Row>({
    header: () => "Option",
    data: (cli) => cli.projectItem.itemTemplateItem?.options.map((o) => o.name).join(", ") || emptyCellDash,
  }),
  column<Row>({ header: () => "Allocation", data: (cli) => cli.projectItem.task?.name ?? emptyCellDash }),
  column<Row>({ header: () => "Internal Note", data: (cli) => cli.internalNote ?? emptyCellDash }),
  column<Row>({ header: () => "Location", data: (cli) => cli.projectItem.location.displayLocationPath }),
  column<Row>({ header: () => "Material Code", data: (cli) => cli.projectItem.materialVariant?.code ?? emptyCellDash }),
  numericColumn<Row>({ header: () => "Quantity", data: (cli) => cli.quantity ?? emptyCellDash }),
  column<Row>({ header: () => "Unit", data: (cli) => cli.projectItem.unitOfMeasure.name }),
];
